import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import {
  type ICommentRepository,
  type ListCommentsParams,
} from '../../../business-logic/interfaces/ICommentRepository'
import { type CommentConstructorData } from '../../../entities/Comment'
import { mapCommentApiModel } from '../../mappers/mapCommentApiModel'
import { type GetCommentsResponse } from '../../types/GetCommentsResponse'

interface Dependency {
  httpClient: IHttpClient
}

export const COMMENTS_ENDPOINT = '/api/v3/comments/'

export class CommentRepository implements ICommentRepository {
  constructor(private readonly deps: Dependency) {}

  async list({
    contentTypeId,
    objectId,
    pageSize,
  }: ListCommentsParams): Promise<CommentConstructorData[]> {
    const res = await this.deps.httpClient.get<GetCommentsResponse>(
      COMMENTS_ENDPOINT,
      {
        params: {
          content_type: contentTypeId,
          object_pk: objectId,
          // Same ordering as the rendered thread.
          order_by: 'id',
          page_size: pageSize,
        },
      }
    )

    return res.data.data.map(mapCommentApiModel)
  }
}
